import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";

const sections = [
  {
    title: "Éditeur du site",
    body: [
      "Brauer Élémentaire — Entrepreneur individuel",
      "Valréas, Vaucluse (84), France",
      "SIRET : 130 951 296 00016",
      "Téléphone : 07 60 40 53 73",
      "Email : brauerelementaire@gmail.com",
    ],
  },
  {
    title: "Directeur de la publication",
    body: ["Le gérant de Brauer Élémentaire."],
  },
  {
    title: "Hébergement",
    body: [
      "Ce site est hébergé via la plateforme Emergent (emergent.sh).",
      "Les données sont stockées de manière sécurisée sur des serveurs cloud.",
    ],
  },
  {
    title: "Propriété intellectuelle",
    body: [
      "L'ensemble des contenus de ce site (textes, logo, mise en page) est la propriété de Brauer Élémentaire, sauf mentions contraires. Toute reproduction sans autorisation écrite est interdite.",
      "Les photographies d'illustration proviennent de la banque d'images libre de droits Unsplash.",
    ],
  },
  {
    title: "Données personnelles (RGPD)",
    body: [
      "Le formulaire de contact collecte uniquement votre nom, votre adresse email et votre message, dans le seul but de répondre à votre demande de devis ou de renseignement.",
      "Ces données ne sont ni vendues, ni cédées à des tiers. Elles sont conservées le temps nécessaire au traitement de votre demande.",
      "Conformément au RGPD, vous disposez d'un droit d'accès, de rectification et de suppression de vos données. Pour l'exercer, écrivez à brauerelementaire@gmail.com.",
    ],
  },
  {
    title: "Cookies",
    body: [
      "Ce site utilise uniquement une mesure d'audience anonyme destinée à améliorer son fonctionnement. Aucun cookie publicitaire n'est déposé.",
    ],
  },
];

export default function MentionsLegales() {
  return (
    <div className="min-h-screen px-6 md:px-12 py-32" data-testid="legal-page">
      <motion.a
        href="/"
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        data-testid="legal-back-link"
        className="inline-flex items-center gap-3 text-xs uppercase tracking-[0.25em] text-ash hover:text-gold transition-colors duration-500 mb-20"
      >
        <ArrowLeft className="w-4 h-4" />
        Retour au site
      </motion.a>

      <motion.div
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, ease: [0.76, 0, 0.24, 1] }}
        className="max-w-3xl"
      >
        <p className="text-xs uppercase tracking-[0.3em] text-gold mb-8">Informations légales</p>
        <h1
          className="font-serif text-5xl md:text-7xl tracking-tighter leading-[0.95] mb-24"
          data-testid="legal-title"
        >
          mentions légales<br />
          <span className="italic font-light text-gold">& confidentialité.</span>
        </h1>

        <div className="space-y-20">
          {sections.map((s, i) => (
            <motion.section
              key={s.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.9, delay: i * 0.05 }}
              className="border-t border-white/10 pt-10"
              data-testid={`legal-section-${i + 1}`}
            >
              <h2 className="font-serif text-2xl md:text-3xl tracking-tight mb-6">{s.title}</h2>
              {s.body.map((p, j) => (
                <p key={j} className="text-sm md:text-base text-ash font-light leading-relaxed mb-3">
                  {p}
                </p>
              ))}
            </motion.section>
          ))}
        </div>

        <p className="text-xs text-ash tracking-[0.2em] mt-24 pt-8 border-t border-white/10">
          © 2026 Brauer Élémentaire — Valréas, Vaucluse
        </p>
      </motion.div>
    </div>
  );
}
